/** Top-level route that renders the blocking maintenance screen. */
export const MAINTENANCE_ROUTE_NAME = 'system-maintenance';

/** Path of {@link MAINTENANCE_ROUTE_NAME}. */
export const MAINTENANCE_ROUTE_PATH = '/maintenance';

/** Set when `domain-brand` reports `maintenanceMode: false` for this tab. */
export const MAINTENANCE_READY_STORAGE_KEY = 'bv.maintenance-backend-ready';

/** Set when `domain-brand` reports `maintenanceMode: true` for this tab. */
export const MAINTENANCE_API_BLOCK_STORAGE_KEY = 'bv.maintenance-api-block';

/** Path to reopen after the screen is lifted. */
export const MAINTENANCE_RETURN_PATH_KEY = 'bv.maintenance-return-path';
